import { Directive, HostBinding, HostListener, Input, inject } from '@angular/core'
import { MatRipple } from '@angular/material/core'

import { OperatorDataState } from '@states/operator-data'

@Directive({
	selector: '[actioner-raised]',
	providers: [MatRipple],
	standalone: true,
})
export class ActionerRaisedDirective {
	readonly #ripple = inject(MatRipple)
	readonly #operatorDataState = inject(OperatorDataState)

	@Input() type: 'button' | 'submit' = 'button'
	@Input() color: 'main' | 'accent' | 'warn' | 'basic' | 'primary' = 'basic'

	@HostBinding('class.actioner-raised') readonly setStyle = true

	@HostBinding('class') get setColor(): string {
		if (this.#operatorDataState.isCurbstand()) {
			return `${this.color} curbstand`
		}

		return this.color
	}

	@HostListener('mousedown', ['$event'])
	onMouseDown(event: MouseEvent): void {
		this.#ripple.launch(event.x, event.y)
		this.#ripple.color = 'rgb(255 255 255 / 8%)'
	}
}
